import { put, select, takeEvery } from "redux-saga/effects";
import { CHANGE_PAGE_TYPE_SAGA } from "../../helpers/constants";
import { changePagePftTemplate, changePageType } from "../../actions/pageInfo";
import type { ChangePageTypeSaga } from "../../actions/pageInfo";
import { changePageVersionHtml } from "../../actions/pageVersions";
import { defaultHtml } from "../../helpers/pageDefaults";
import { getPageInfo } from "../../selectors/page";
import { resetPageModifiers } from "../../actions/pageModifiers";
import type { State as PageInfoState } from "../../reducers/pageInfo";

export function* applyAction(action: ChangePageTypeSaga) {
  const { pageType: nextPageType }: ChangePageTypeSaga = action;

  const pageInfo: PageInfoState = yield select(getPageInfo);
  const prevPageType = pageInfo.get("pageType");

  yield put(changePageType(nextPageType));
  yield put(changePagePftTemplate("", ""));
  yield put(resetPageModifiers());

  if (nextPageType === "pft") {
    yield put(changePageVersionHtml("new", ""));
  }
  if (prevPageType === "pft") {
    yield put(changePageVersionHtml("new", defaultHtml));
  }
}

export default function* watch() {
  yield takeEvery(CHANGE_PAGE_TYPE_SAGA, applyAction);
}
